export const ROLE_OWNER = "owner";
export const ROLE_ADMIN = "admin";
export const ROLE_TECH = "lead_technician";
export const ROLE_CRAFTSMAN = "craftsman";

export const ROLE_LABELS = { owner: "Vlastník", admin: "Administrátor", lead_technician: "Vedoucí technik", technician: "Vedoucí technik", craftsman: "Řemeslník" };

export const roleLabel = (r) => ROLE_LABELS[r] || "";
export const isTech = (user) => user?.role === ROLE_TECH || user?.role === "technician";
export const isOwner = (user) => user?.role === ROLE_OWNER;
export const isOffice = (user) => user?.role === ROLE_OWNER || user?.role === ROLE_ADMIN;
export const isCraftsman = (user) => user?.role === ROLE_CRAFTSMAN;
export const homePath = (user) => (isCraftsman(user) ? "/hodiny" : "/");

// Cesty, které smí otevřít vedoucí technik (ostatní → přesměrování na Přehled)
const TECH_PATHS = ["/", "/zakazky", "/planovac", "/mapa", "/ukoly", "/profil", "/rozpocty", "/kniha-jizd", "/tym", "/naradi", "/kontrola-hodin"];
// Cesty pro řemeslníka (jen hodiny a kniha jízd)
const CRAFTSMAN_PATHS = ["/hodiny", "/kniha-jizd", "/profil", "/naradi"];
// Cesty jen pro vlastníka
const OWNER_PATHS = ["/nastaveni", "/historie"];

export function canAccessPath(user, pathname) {
    if (!user) return false;
    const base = "/" + (pathname.split("/")[1] || "");
    if (base === "/hodiny") return isCraftsman(user);
    if (pathname.startsWith("/remeslnici/dochazka")) return true;
    if (isOwner(user)) return true;
    if (OWNER_PATHS.includes(base)) return false;
    if (isTech(user)) return TECH_PATHS.includes(base);
    if (isCraftsman(user)) return CRAFTSMAN_PATHS.includes(base);
    return true;
}
